import { runtimeEnv } from "@/core/lib/runtime-env";

import faviconSvg from "../../../public/favicon.svg?raw";

export function faviconColor(environment: string | undefined): string {
  switch (environment) {
    case "production":
      return "#F9B800";
    case "staging":
      return "#008DF9";
    default:
      return "#439616";
  }
}

// the environment is only known once env.js has loaded, so index.html ships the
// plain icon and this swaps in the recolored one at startup
export function applyEnvironmentFavicon(): void {
  const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) return;

  const color = faviconColor(runtimeEnv("VITE_DEPLOYMENT_ENVIRONMENT"));
  const svg = faviconSvg.replace('fill="#F9B800"', `fill="${color}"`);
  link.href = `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
